module.exports = __webpack_public_path__ + "static/media/HEDERA-blatt.9d810cd4.png";